export function ioExtend(_rightObject: {}, _leftObject: {}, _type: 'RightJoin' | 'CrossJoin' = 'RightJoin') {
    if (_type === 'RightJoin') {
        RightJoin(_rightObject, _leftObject);
    } else {
        CrossJoin(_rightObject, _leftObject);
    }
    return _rightObject;
}

function RightJoin(_rightObject: {}, _leftObject: {}) {
    if (_rightObject && _leftObject) {
        const _rightProperties = Object.getOwnPropertyNames(_rightObject);
        _rightProperties.forEach(_rKey => {
            const d: { writable?: boolean } = Object.getOwnPropertyDescriptor(_rightObject, _rKey);
            if (d.writable) {
                Object.getOwnPropertyNames(_leftObject).forEach(_lKey => {
                    if (_rKey.toLowerCase() === _lKey.toLowerCase()) {
                        _rightObject[_rKey] = _leftObject[_lKey];
                    }
                });
            }
        });
    }
    return _rightObject;
}

function CrossJoin(_rightObject: {}, _leftObject: {}) {
    if (_rightObject && _leftObject) {
        const _rightProperties = Object.getOwnPropertyNames(_rightObject);
        _rightProperties.forEach(_rKey => {
            const d = Object.getOwnPropertyDescriptor(_rightObject, _rKey);
            if (d.writable) {
                Object.getOwnPropertyNames(_leftObject).forEach(_lKey => {
                    _rightObject[_lKey] = _leftObject[_lKey];
                });
            }
        });
    }
    return _rightObject;
}
